import axios from 'axios';
import { API_BASE } from '../Config';

// Create a separate axios instance for public APIs (no auth required)
const publicApiInstance = axios.create({
  baseURL: API_BASE,
});

export default publicApiInstance;